import { render, staticRenderFns } from "./button-jelly.vue?vue&type=template&id=00b35f79&scoped=true&"
var script = {}
import style0 from "./button-jelly.vue?vue&type=style&index=0&id=00b35f79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b35f79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b35f79')) {
      api.createRecord('00b35f79', component.options)
    } else {
      api.reload('00b35f79', component.options)
    }
    module.hot.accept("./button-jelly.vue?vue&type=template&id=00b35f79&scoped=true&", function () {
      api.rerender('00b35f79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/button-jelly.vue"
export default component.exports